export enum NOTIFICATION_TYPES {
  ERROR = 'error',
  WARNING = 'warning',
  SUCCESS = 'success',
  INFO = 'info',
}

export const AUTO_HIDE_DURATION_TIME = 10000;
